import { render, staticRenderFns } from "./feedbacks.vue?vue&type=template&id=3673b322&scoped=true&"
import script from "./feedbacks.vue?vue&type=script&lang=js&"
export * from "./feedbacks.vue?vue&type=script&lang=js&"
import style0 from "./feedbacks.vue?vue&type=style&index=0&id=3673b322&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3673b322",
  null
  
)

export default component.exports